export default "__VITE_ASSET__C0rnAed3__"